import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import DetalheProcedimento from "./components/DetalheProcedimento";
import DetalheDenuncia from "./components/DetalheDenuncia";
import DetalheCobranca from "./components/DetalheCobranca";
import DetalheParteServico from "./components/DetalheParteServico";

const ConsultaDetalheProcedimentoFiscal = ({ history }) => {
  const [tipoOrigem, setTipoOrigem] = useState("");
  const [numSpf, setNumSpf] = useState(0);
  const [keys, setKeys] = useState(0);

  useEffect(() => {
    const searchParams = new URLSearchParams(history?.location?.search);
    setKeys(searchParams.get("itemKey"));
    setNumSpf(searchParams.get("numSpf"));
    setTipoOrigem(searchParams.get("numSpf") ? "S" : searchParams.get("origem"));
  }, [history]);

  return (
    <>
      {/* Cabeçalho da Página */}
      <h1 className="h3 mb-4 text-gray-800">Procedimento Fiscal</h1>
      <div className="row">
        <div className="col-lg-12">
          {tipoOrigem === "S" && <DetalheProcedimento history={history} spf={numSpf} />}
          {tipoOrigem === "D" && <DetalheDenuncia id={keys} history={history} />}
          {tipoOrigem === "C" && <DetalheCobranca id={keys} history={history} />}
          {tipoOrigem === "P" && <DetalheParteServico id={keys} history={history} />}
          <Row style={{ marginTop: "30px" }} className="py-2">
            <Col sm="2">
              {keys == null ? (
                <Button
                  variant="danger"
                  onClick={() => {
                    // history.push({ pathname: "/app/spf/pendencias", state: history.location.pathname });
                    history.goBack();
                  }}
                >
                  Voltar
                </Button>
              ) : null}
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default ConsultaDetalheProcedimentoFiscal;
